import { SUPPORTED_LANGUAGES } from '@/configs/i18n-constants';
import account from '@/lang/account/';
import advancesPage from '@/lang/advances-page/';
import applicationPage from '@/lang/application-page/';
import backendErrors from '@/lang/backend-errors/';
import documents from '@/lang/documents/';
import general from '@/lang/general/';
import paymentsPage from '@/lang/payments-page/';
import spendPage from '@/lang/spend-page/';
import teamPage from '@/lang/team-page';
import vendorsPage from '@/lang/vendors-page/';

const translations = [
  account,
  advancesPage,
  applicationPage,
  backendErrors,
  documents,
  general,
  paymentsPage,
  spendPage,
  teamPage,
  vendorsPage,
];

const locales = Object.values(SUPPORTED_LANGUAGES);

const messages = translations.reduce((acc, current) => {
  locales.forEach((locale) => {
    const currentLocale = acc?.[locale] ?? {};
    acc[locale] = { ...current[locale], ...currentLocale };
  });
  return acc;
}, {});

export default messages;
